export default __webpack_public_path__ + "static/media/banner-bg-dez-anos-seguridade.df85cdc2.png";